// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.size_m {
    background-image: linear-gradient(240deg, #4985FF, #4986ffca);
    margin-top: 10px;
    border-radius: 5px;
    border: 1px solid rgba(255, 255, 255, 0.26);
    width: 100px;
    height: 40px;
    font-family: 16px;
    box-shadow: 1px 1px 5px rgba(128, 128, 128, 0.498);
 }
 
 .size_l {
    background-image: linear-gradient(240deg, #4985FF, #4986ff99);
    border-radius: 5px;
    margin-top: 10px;
    border: 1px solid rgba(255, 255, 255, 0.26);
    width: 200px;
    height: 45px;
    font-family: 24px;
    box-shadow: 5px 5px 5px rgba(128, 128, 128, 0.429);
 }
 
 .size_xl {
    background-image: linear-gradient(240deg, #4985FF, #4986ffca);
    border-radius: 5px;
    margin-top: 10px;
    border: 1px solid rgba(255, 255, 255, 0.26);
    width: 250px;
    height: 50px;
    font-family: 32px;
    box-shadow: 5px 5px 5px rgba(128, 128, 128, 0.415);
 }
 
 
 .disabled {
    background-image: linear-gradient(240deg, #4985FF, #4986ffa7);
    border-radius: 5px;
    margin-top: 10px;
    border: 1px solid rgba(255, 255, 255, 0.26);
    opacity: 0.5;
    cursor: auto;
 }
 
 .default {
    background-image: linear-gradient(240deg, #4985FF, #4986ffca);
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.26);
    padding: 10px;
 }
 
 button {
    position: relative;
    overflow: hidden;
    transition: 0.3s all;
 }
 
 button:hover {
    cursor: pointer;
    transform: scale(1.05);
    transition: 0.3s all;
 }
 
 button:hover::before {
    left: calc(100% + 150px);
    transition: 2s;
 }
 
 button:focus::before {
    left: calc(100% + 150px);
    transition: 2s;
 }
 
 button:focus::after {
    left: calc(100% + 150px);
    transition: 2s;
 }
 
 button:hover::after {
    left: calc(100% + 150px);
    transition: 2s;
 }
 
 button::before {
    content: '';
    position: absolute;
    top: 0;
    left: -200px;
    width: 60px;
    height: 100%;
    background-color: white;
    filter: blur(40px);
    transform: skew(-30deg);
 }
 
 button::after {
    content: '';
    position: absolute;
    top: 0;
    left: -200px;
    width: 60px;
    height: 100%;
    background-color: white;
    filter: blur(40px);
    transform: skew(-30deg);
 }
 
 .btn_shine::after{
    left: calc(100% + 150px);
    transition: 4s all 1.5s;
    z-index: 1;
    width: 100px;
    height: 100px;
    background-color: white;
 }`, "",{"version":3,"sources":["webpack://./src/shared/ui/buttons/Buttons.css"],"names":[],"mappings":"AAAA;IACI,6DAA6D;IAC7D,gBAAgB;IAChB,kBAAkB;IAClB,2CAA2C;IAC3C,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kDAAkD;CACrD;;CAEA;IACG,6DAA6D;IAC7D,kBAAkB;IAClB,gBAAgB;IAChB,2CAA2C;IAC3C,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kDAAkD;CACrD;;CAEA;IACG,6DAA6D;IAC7D,kBAAkB;IAClB,gBAAgB;IAChB,2CAA2C;IAC3C,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kDAAkD;CACrD;;;CAGA;IACG,6DAA6D;IAC7D,kBAAkB;IAClB,gBAAgB;IAChB,2CAA2C;IAC3C,YAAY;IACZ,YAAY;CACf;;CAEA;IACG,6DAA6D;IAC7D,mBAAmB;IACnB,2CAA2C;IAC3C,aAAa;CAChB;;CAEA;IACG,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;CACvB;;CAEA;IACG,eAAe;IACf,sBAAsB;IACtB,oBAAoB;CACvB;;CAEA;IACG,wBAAwB;IACxB,cAAc;CACjB;;CAEA;IACG,wBAAwB;IACxB,cAAc;CACjB;;CAEA;IACG,wBAAwB;IACxB,cAAc;CACjB;;CAEA;IACG,wBAAwB;IACxB,cAAc;CACjB;;CAEA;IACG,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,uBAAuB;CAC1B;;CAEA;IACG,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,uBAAuB;CAC1B;;CAEA;IACG,wBAAwB;IACxB,uBAAuB;IACvB,UAAU;IACV,YAAY;IACZ,aAAa;IACb,uBAAuB;CAC1B","sourcesContent":[".size_m {\n    background-image: linear-gradient(240deg, #4985FF, #4986ffca);\n    margin-top: 10px;\n    border-radius: 5px;\n    border: 1px solid rgba(255, 255, 255, 0.26);\n    width: 100px;\n    height: 40px;\n    font-family: 16px;\n    box-shadow: 1px 1px 5px rgba(128, 128, 128, 0.498);\n }\n \n .size_l {\n    background-image: linear-gradient(240deg, #4985FF, #4986ff99);\n    border-radius: 5px;\n    margin-top: 10px;\n    border: 1px solid rgba(255, 255, 255, 0.26);\n    width: 200px;\n    height: 45px;\n    font-family: 24px;\n    box-shadow: 5px 5px 5px rgba(128, 128, 128, 0.429);\n }\n \n .size_xl {\n    background-image: linear-gradient(240deg, #4985FF, #4986ffca);\n    border-radius: 5px;\n    margin-top: 10px;\n    border: 1px solid rgba(255, 255, 255, 0.26);\n    width: 250px;\n    height: 50px;\n    font-family: 32px;\n    box-shadow: 5px 5px 5px rgba(128, 128, 128, 0.415);\n }\n \n \n .disabled {\n    background-image: linear-gradient(240deg, #4985FF, #4986ffa7);\n    border-radius: 5px;\n    margin-top: 10px;\n    border: 1px solid rgba(255, 255, 255, 0.26);\n    opacity: 0.5;\n    cursor: auto;\n }\n \n .default {\n    background-image: linear-gradient(240deg, #4985FF, #4986ffca);\n    border-radius: 10px;\n    border: 1px solid rgba(255, 255, 255, 0.26);\n    padding: 10px;\n }\n \n button {\n    position: relative;\n    overflow: hidden;\n    transition: 0.3s all;\n }\n \n button:hover {\n    cursor: pointer;\n    transform: scale(1.05);\n    transition: 0.3s all;\n }\n \n button:hover::before {\n    left: calc(100% + 150px);\n    transition: 2s;\n }\n \n button:focus::before {\n    left: calc(100% + 150px);\n    transition: 2s;\n }\n \n button:focus::after {\n    left: calc(100% + 150px);\n    transition: 2s;\n }\n \n button:hover::after {\n    left: calc(100% + 150px);\n    transition: 2s;\n }\n \n button::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: -200px;\n    width: 60px;\n    height: 100%;\n    background-color: white;\n    filter: blur(40px);\n    transform: skew(-30deg);\n }\n \n button::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: -200px;\n    width: 60px;\n    height: 100%;\n    background-color: white;\n    filter: blur(40px);\n    transform: skew(-30deg);\n }\n \n .btn_shine::after{\n    left: calc(100% + 150px);\n    transition: 4s all 1.5s;\n    z-index: 1;\n    width: 100px;\n    height: 100px;\n    background-color: white;\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
